module.exports = __webpack_public_path__ + "img/co_wrapbg7.83c15d06.png";